import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { JwtLegFiClaims } from '../../services/auth/jwt-legfi-claims.model';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';

@Directive({
    selector: '[featureFlag]',
})
export class FeatureFlagDirective implements OnInit
{
    @Input() featureFlag: string;

    constructor(
            private vcr: ViewContainerRef,
            private tpl: TemplateRef<any>,
    ) {
    }

    ngOnInit() {
        if (this.hasFeatureEnabled()) {
            this.vcr.createEmbeddedView(this.tpl);
        }
    }

    /**
     * As features are developed, add logic to determine whether they are locked or not to this function
     * When a feature is rolled out to everyone, remove the logic from this function
     */
    hasFeatureEnabled() {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();

        if (this.featureFlag === 'reconciliation') {
            // Bank reconciliation released to all organizations on 12/22/2020
            // return [7587].indexOf(jwt.orgId) !== -1 || jwt.superUser;
        }

        return true;
    }
}
